import { Instance } from '../../Utility/Instance';
import { LabOptions } from './LabOptions';

/**
 * @deprecated Use `FeatureEnrollment.isEnrolledIn()` or `platform().getNamedValue()` instead.
 */
export const labOptions = new Instance<LabOptions>();
